export const SITE_ORIGIN = (import.meta.env.VITE_SITE_URL || '').replace(/\/+$/, '');